/**
 * SecureEmbed Energy Portal - Colour Constants
 */

export const DATASOURCE_COLORS: Record<string, { hex: string; bg: string; text: string; border: string; label: string }> = {
  aemo: { hex: '#F59E0B', bg: 'bg-amber-100', text: 'text-amber-700', border: 'border-amber-300', label: 'AEMO Energy' },
  'aemo-duid': { hex: '#6366F1', bg: 'bg-indigo-100', text: 'text-indigo-700', border: 'border-indigo-300', label: 'AEMO DUID' },
  'aemo-fcas': { hex: '#14B8A6', bg: 'bg-teal-100', text: 'text-teal-700', border: 'border-teal-300', label: 'AEMO FCAS' },
  bom: { hex: '#3B82F6', bg: 'bg-blue-100', text: 'text-blue-700', border: 'border-blue-300', label: 'BOM Weather' },
  aer: { hex: '#10B981', bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-300', label: 'AER Regulatory' },
  regulatory: { hex: '#059669', bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-300', label: 'Regulatory Documents' },
  scholarly: { hex: '#0EA5E9', bg: 'bg-sky-100', text: 'text-sky-700', border: 'border-sky-300', label: 'Scholarly Research' },
  'energy-organisations': { hex: '#8B5CF6', bg: 'bg-violet-100', text: 'text-violet-700', border: 'border-violet-300', label: 'Energy Organisations' },
  'grid-connection-queue': { hex: '#F97316', bg: 'bg-orange-100', text: 'text-orange-700', border: 'border-orange-300', label: 'Grid Connection Queue' },
  'rez-capacity': { hex: '#10B981', bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-300', label: 'REZ Capacity' },
  'ppa-intelligence': { hex: '#F43F5E', bg: 'bg-rose-100', text: 'text-rose-700', border: 'border-rose-300', label: 'PPA Intelligence' },
  'network-constraints': { hex: '#06B6D4', bg: 'bg-cyan-100', text: 'text-cyan-700', border: 'border-cyan-300', label: 'Network Constraints' },
  'planning-approvals': { hex: '#D97706', bg: 'bg-amber-100', text: 'text-amber-700', border: 'border-amber-300', label: 'Planning Approvals' },
  'construction-milestones': { hex: '#0EA5E9', bg: 'bg-sky-100', text: 'text-sky-700', border: 'border-sky-300', label: 'Construction Milestones' },
  'community-sentiment': { hex: '#EC4899', bg: 'bg-pink-100', text: 'text-pink-700', border: 'border-pink-300', label: 'Community Sentiment' },
  partner: { hex: '#EC4899', bg: 'bg-pink-100', text: 'text-pink-700', border: 'border-pink-300', label: 'Partner & Quantum Discovery' },
  custom: { hex: '#6B7280', bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300', label: 'Custom' },
};

export const CHART_COLORS = {
  aemo: '#F59E0B',
  bom: '#3B82F6',
  aer: '#10B981',
  primary: '#2B064F',
  secondary: '#7C3AED',
  accent: '#EC4899',
  neutral: '#6B7280',
};

export const BRAND = {
  primary: '#2B064F',
  primaryLight: '#4A0E78',
  primaryDark: '#1a0436',
};

export const RECHARTS_THEME = {
  grid: { stroke: '#E5E7EB', strokeDasharray: '3 3' },
  tooltip: {
    contentStyle: {
      backgroundColor: '#fff',
      border: '1px solid #E5E7EB',
      borderRadius: '12px',
      boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
      fontSize: '12px',
    },
  },
  label: { fontSize: 12, fill: '#6B7280' },
};
